(function () {
	'use strict';

	angular.module('app.core')
		.service('userService', userService);

	userService.$inject = ['$rootScope', '$http', '$window', 'URLS'];

	function userService($rootScope, $http, $window, URLS) {
		var service = {
			switchSite: switchSite
		};

		return service;

		function switchSite(siteId, preservePath) {
			var pageUrl = String.format(URLS.switchSite, siteId);
			return $http.post(pageUrl)
				.then(switchSiteComplete)
				.catch(switchSiteFailed);

			function switchSiteComplete(response) {
				if (preservePath) {
					$window.location.reload();
				} else {
					var path = undefined;
					if (response.data.homePage) {
						path = encodeURIComponent(response.data.homePage);
					}
					location.href = $window.location.protocol + '//' + $window.location.host + '/application/factory-switch.html?p=' + path;
				}
			}

			function switchSiteFailed(error) {
				$rootScope.$emit('toast', {
					'message': 'We could not switch your site. Please try again later.',
					'success': false
				});
				return [];
			}
		}
	}
})();
